import { useMutation, useQueryClient } from "@tanstack/react-query"
import { DELETEBankAccount } from "../requests"
import { BANK_ACCOUNT_QUERY_KEY } from "./useGetBankAccount"

export const useDeleteBankAccount = () => {
    const queryClient = useQueryClient()
    
    return useMutation({
        mutationFn: async () => await DELETEBankAccount(),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [BANK_ACCOUNT_QUERY_KEY],
            })},
})
}